import html2canvas from 'html2canvas';
import { MutableRefObject } from 'react';
import { getFormattedTimestamp } from '@/utils/misc.ts';

export const captureScreenshot = (screenshotRef: MutableRefObject<null>, contractName: string) => {
  const style = document.createElement('style');
  document.head.appendChild(style);
  // Needed for screenshot to unshift text in input fields
  style.sheet?.insertRule('body > div:last-child img { display: inline-block; }');

  const canvasPromise = html2canvas(screenshotRef.current!, {})
  canvasPromise.then(canvas => {
    const image = canvas.toDataURL('image/png')
    const a = document.createElement('a')
    const timestamp = getFormattedTimestamp()
    a.setAttribute('download', `${contractName}_${timestamp}.png`)
    a.setAttribute('href', image)
    a.click()
    canvas.remove()
  })
}
